export default __webpack_public_path__ + "static/media/compu-negro@3x.e4af7af6.png";